// extracted by mini-css-extract-plugin
export var masthead = "MSXV8";
export var mastheadImage = "N6I9P";